var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      class: [
        "streak-count",
        _vm.streakTriumph,
        "streak-count-" + this.size,
        { "streak-count-on-streak": _vm.progress === 1 },
        { "streak-count-two-digits": _vm.currentStreak >= 10 },
        { mobile: _vm.mobile }
      ],
      style: { minWidth: _vm.diameter },
      attrs: {
        width: _vm.diameter,
        height: _vm.diameter,
        viewBox: "0 0 " + _vm.diameter + " " + _vm.diameter,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", {
        staticClass: "ring",
        attrs: {
          "stroke-width": _vm.stroke,
          r: _vm.normalizedRadius,
          cx: _vm.center,
          cy: _vm.center
        }
      }),
      _vm._v(" "),
      _c("circle", {
        staticClass: "progress-ring",
        style: { strokeDashoffset: _vm.strokeDashOffsetVal },
        attrs: {
          "stroke-linecap": "round",
          "stroke-width": _vm.stroke,
          r: _vm.normalizedRadius,
          cx: _vm.center,
          cy: _vm.center,
          "stroke-dasharray": _vm.circumference + " " + _vm.circumference,
          fill: "transparent"
        }
      }),
      _vm._v(" "),
      _vm.currentStreak || _vm.size !== "big"
        ? _c("g", [
            _c("rect", {
              staticClass: "dot",
              attrs: { x: "10%", y: "84%", width: "6%", height: "6%" }
            }),
            _vm._v(" "),
            _c("rect", {
              staticClass: "dot",
              attrs: { x: "5%", y: "74%", width: "4%", height: "4%" }
            }),
            _vm._v(" "),
            _c("rect", {
              staticClass: "dot",
              attrs: {
                x: "87%",
                y: "14%",
                width: "4%",
                height: "4%",
                transform:
                  "rotate(82 " +
                  this.diameter * 0.87 +
                  " " +
                  this.diameter * 0.14 +
                  ")"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowLighting
        ? _c("path", {
            staticClass: "thunder",
            attrs: {
              d:
                "M66.0571 37.6701H61.3117L63.0708 32.1754C63.2344 31.4939 62.7435 30.855 62.1299 30.855H56.239C55.7481 30.855 55.2981 31.2383 55.2572 31.7495L53.9481 41.9722C53.8663 42.6111 54.3163 43.1223 54.9299 43.1223H59.7572L57.8753 51.4283C57.7526 52.0672 58.2026 52.6635 58.8163 52.6635C59.1844 52.6635 59.5117 52.4931 59.6753 52.1524L66.8753 39.2036C67.2844 38.5646 66.7935 37.6701 66.0571 37.6701Z"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowCurrentStreak
        ? _c(
            "text",
            {
              staticClass: "current-streak",
              attrs: {
                "text-anchor": "middle",
                "dominant-baseline": "middle",
                x: _vm.textXPosition,
                y: "52%",
                fill: "black",
                "data-testid": "streak_count_current_streak"
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.currentStreak) + "\n  ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }